/**
 * S-89: サインインフォームの純関数（入力検証 + AuthError → 表示文言）。
 *
 * 従来は各 app の SignInPage.tsx / lib/auth.tsx に同一実装がコピーされていた。
 * 横断修正のたびに 5 app の同期が必要だったため単一ソース化する。
 */
/** Pure: サインインフォームの入力検証。 */
export function validateSignInForm(email, password) {
    const errors = {};
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
        errors.email = 'メールアドレスを入力してください';
    }
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
        errors.email = 'メールアドレスの形式が正しくありません';
    }
    if (!password) {
        errors.password = 'パスワードを入力してください';
    }
    return errors;
}
/**
 * サインイン時の Firebase AuthError → 表示用日本語メッセージ。
 *
 * セキュリティ（S-89 アカウント列挙対策）: `auth/user-not-found` / `auth/user-disabled`
 * はアカウントの存在有無・状態を攻撃者に教えないよう、wrong-password と同一の文言に
 * 統一する。無効化されたアカウントの本人への案内は運用（管理者からの連絡）で行う。
 *
 * `auth/too-many-requests` に具体的な回数・待ち時間を含めないのも同じ理由
 * （レート制限のしきい値を教えない）。
 */
export function mapAuthErrorMessage(code) {
    switch (code) {
        case 'auth/invalid-email':
            return 'メールアドレスの形式が正しくありません';
        case 'auth/missing-password':
        case 'auth/wrong-password':
        case 'auth/invalid-credential':
        case 'auth/user-not-found':
        case 'auth/user-disabled':
            return 'メールアドレスまたはパスワードが正しくありません';
        case 'auth/too-many-requests':
            return '試行回数が多すぎます。しばらく待ってから再度お試しください';
        case 'auth/network-request-failed':
            return 'ネットワークエラーが発生しました。接続を確認してください';
        default:
            return 'サインインに失敗しました。時間をおいて再度お試しください';
    }
}
//# sourceMappingURL=signInPure.js.map